import {
  useVst4PoolPrice,
  useVstaWethPrice,
  useVstFraxPrice,
} from '~components/hooks/protocol/assets/lpPriceHooks';
import { ELPType } from '~config/types';

export interface LPPricesResponse {
  data: { [index in ELPType]: number };
  isLoading: boolean;
  isFetched: boolean;
  isFetching: boolean;
}

//adding lp prices through the config was such a nightmare, this is where we will get it for now, until
//we can find a more sheeeeeeesh way lol
export const useLPPrices = (): LPPricesResponse => {
  const {
    data: vstFrax,
    isLoading: isVstFraxLoading,
    isFetched: isVstFraxFetched,
    isFetching: vstFraxFetching,
  } = useVstFraxPrice();
  const {
    data: wethVsta,
    isLoading: isWethVstaLoading,
    isFetched: isWethVstaFetched,
    isFetching: vstaWethFetching,
  } = useVstaWethPrice();
  const {
    data: fourPool,
    isLoading: is4PoolLoading,
    isFetched: is4PoolFetched,
    isFetching: vst4poolFetching,
  } = useVst4PoolPrice();

  return {
    data: {
      [ELPType['VST-USDC']]: 0,
      [ELPType['VST-FRAX']]: vstFrax,
      [ELPType['VSTA-ETH']]: wethVsta,
      [ELPType['VST-USDC-DAI-USDT']]: fourPool,
    },
    isLoading: isVstFraxLoading || isWethVstaLoading || is4PoolLoading,
    isFetched: isVstFraxFetched || isWethVstaFetched || is4PoolFetched,
    isFetching: vstFraxFetching || vstaWethFetching || vst4poolFetching,
  };
};
